import React, { useState, useEffect } from 'react';
import styles from '../AssignedJobsSection.module.css';
import { fmtHrs, fmtUSD } from './jobsApi';

// ── Unmark payment (void confirmation) modal ────────────────────────────────
// A job is paid exactly once, so there's at most one active payment to void —
// this is a plain confirm, not a list to pick from.

const UnmarkPaymentsModal = ({ job, onCancel, onVoided, getHeaders, jobsBaseUrl }) => {
    const [payment, setPayment] = useState(null);
    const [loading, setLoading] = useState(false);
    const [voiding, setVoiding] = useState(false);
    const [err, setErr] = useState('');

    useEffect(() => {
        let cancelled = false;
        setLoading(true);
        fetch(`${jobsBaseUrl}/${job.job_id}/payments`, { headers: getHeaders() })
            .then((res) => res.json())
            .then((json) => {
                if (cancelled) return;
                setPayment((json.data || [])[0] || null);
            })
            .catch(() => { if (!cancelled) setPayment(null); })
            .finally(() => { if (!cancelled) setLoading(false); });
        return () => { cancelled = true; };
    }, [job.job_id, jobsBaseUrl, getHeaders]);

    const handleConfirm = async () => {
        if (!payment) return;
        setVoiding(true);
        setErr('');
        try {
            const res = await fetch(`${jobsBaseUrl}/${job.job_id}/payments/void`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', ...getHeaders() },
                body: JSON.stringify({ payment_ids: [payment.job_payment_id] }),
            });
            const json = await res.json();
            if (!res.ok || !json.success) throw new Error(json.msg || 'Failed to mark unpaid');
            onVoided(json.data);
        } catch (e) {
            setErr(e.message || 'Failed to mark unpaid.');
        } finally {
            setVoiding(false);
        }
    };

    return (
        <div className={styles.moOverlay}>
            <div className={styles.moDim} onClick={onCancel} />
            <div className={styles.modal} style={{ width: 420 }}>
                <div className={styles.modalHdr}>
                    <span className={styles.modalTitle}>Mark unpaid</span>
                    <button className={styles.dClose} onClick={onCancel}>×</button>
                </div>
                <div className={styles.modalBody}>
                    {loading && <div className={styles.episodeEmpty}>Loading…</div>}

                    {!loading && !payment && (
                        <div className={styles.episodeEmpty}>No active payment to unmark.</div>
                    )}

                    {!loading && payment && (
                        <div className={styles.deleteCopy}>
                            Mark <strong>{fmtUSD(payment.total_amount_usd)}</strong>
                            {' '}({fmtHrs(payment.total_hours)} h, paid {payment.paid_at ? payment.paid_at.slice(0, 10) : '—'})
                            {' '}unpaid for <strong>JOB-{job.job_id}</strong>? A new payment can be recorded afterward.
                        </div>
                    )}

                    {err && <div className={styles.errMsg} style={{ display: 'block' }}>{err}</div>}
                </div>
                <div className={styles.modalFtr}>
                    <button className={styles.btnGhost} onClick={onCancel} disabled={voiding}>Cancel</button>
                    <button
                        className={styles.btnDanger}
                        onClick={handleConfirm}
                        disabled={voiding || !payment}
                    >
                        {voiding ? 'Marking…' : 'Mark unpaid'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default UnmarkPaymentsModal;
